import React from "react";

import { SiteRules } from "components/SiteRules";

const SiteRulesPage = () => {
  return <SiteRules />;
};
export default SiteRulesPage;
